import React from 'react'

export const CountdownTimer = ({ timeLeft }) => {
  return (
    <div className="flex items-center justify-center py-4 bg-gray-200 font-body">
      <span className="leading-tight">
        <span className="font-bold text-brand-red">{timeLeft.days} days </span>{' '}
        until the voter registration deadline
      </span>
    </div>
  )
}
